// extracted by mini-css-extract-plugin
module.exports = {"el":"Tag_el__2V9tY"};